// PRODUCTION — flow editor three-column body
import React from 'react'
import tw from 'twin.macro'
import { useFlowEditorContext } from 'src/pages/admin/flow-editor/context/useFlowEditorContext'
import { FlowEditorLiveUpdatesPanel } from '../preview/FlowEditorLiveUpdatesPanel'
import { FlowEditorStepGroupSidebar } from '../FlowEditorStepGroupSidebar'
import { FlowEditorConfigPanel } from './FlowEditorConfigPanel'

export function FlowEditorMainLayout() {
  const { isCreateMode } = useFlowEditorContext()

  return (
    <div css={tw`flex min-h-0 flex-1 gap-4`}>
      {/*
        The live-updates panel previews which drivers a pending change will affect, which only has
        meaning for a template that exists and has drivers on it. In new-template mode there is
        nothing to preview — and the endpoint is id-bound, so it cannot be called at all — so the
        panel is hidden rather than left showing a permanent "No pending changes" empty state.
      */}
      {!isCreateMode && <FlowEditorLiveUpdatesPanel />}
      <FlowEditorStepGroupSidebar />
      <FlowEditorConfigPanel />
    </div>
  )
}
